import React, { useState } from "react";
import "../../styles/MenuPromotionCard.css";
const originalText = (value) => value;

export default function MenuPromotionCard({
  title, kind, headline, description, imageUrl, schedule, validity, scope,
  items = [], pricingSummary, cashOnly, available, selectable, onOpen, tx = originalText,
}) {
  const [failedImage, setFailedImage] = useState("");
  const benefit = pricingSummary || (headline !== kind && headline !== title ? headline : "");
  return (
    <article className="menu-offer">
      <button type="button" className="menu-offer-cover" onClick={onOpen}
        disabled={!selectable} aria-label={`${tx("Ver detalle de")} ${tx(title)}`}>
        {imageUrl && imageUrl !== failedImage && (
          <img src={imageUrl} alt="" loading="lazy" onError={() => setFailedImage(imageUrl)} />
        )}
        <span className="menu-offer-shade" />
        <span className="menu-offer-badges">
          <span className="menu-offer-kind">{tx(kind)}</span>
          <span className="menu-offer-status">{tx(available ? "Disponible ahora" : "Programada")}</span>
        </span>
        <strong className="menu-offer-title">{tx(title)}</strong>
      </button>
      <div className="menu-offer-body">
        {scope && <span className="menu-offer-scope">{tx(scope)}</span>}
        {description && <p className="menu-offer-description">{tx(description)}</p>}
        {items.length > 0 && <p className="menu-offer-items">{items.join(" + ")}</p>}
        {cashOnly && <strong className="menu-offer-condition">{tx("Solo efectivo")}</strong>}
        {(schedule || validity) && (
          <details className="menu-offer-schedule">
            <summary>{tx("Dias y horarios")}</summary>
            <p>{[schedule, validity].filter(Boolean).map((value) => tx(value)).join(" / ")}</p>
          </details>
        )}
        <div className="menu-offer-footer">
          {benefit && <strong className="menu-offer-benefit">{tx(benefit)}</strong>}
          <button type="button" className="menu-offer-action" onClick={onOpen} disabled={!selectable}>
            {tx(selectable ? "Ver detalle" : "No disponible ahora")}
          </button>
        </div>
      </div>
    </article>
  );
}
